// komponent karty typu procesu

import React, { FC, ReactNode } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';

import { Button } from 'components/controls';

import styles from 'theme/components/containers/ProcessTypeCard/ProcessTypeCard.module.scss';

interface IProcessTypeCardProps {
  type: 'policy' | 'listener' | 'additional_fields' | 'validator' | 'product_label' | 'provider';
  title: string;
  description: string;
  icon: ReactNode;
  onCreate: (type: 'policy' | 'listener' | 'additional_fields' | 'validator' | 'product_label' | 'provider') => void;
}

const ProcessTypeCard: FC<IProcessTypeCardProps> = ({
  type,
  title,
  description,
  icon,
  onCreate
}) => {
  const { t } = useTranslation();

  return (
    <div
      className={classnames(
        styles.componentWrapper,
        styles[type],
        'StylePath-Components-Containers-ProcessTypeCard'
      )}>
      <div className={styles.iconWrapper}>{icon}</div>
      <h3 className={styles.title}>{title}</h3>
      <p className={styles.description}>{description}</p>
      <div className={styles.createButton}>
        <Button onClick={() => onCreate(type)}>{t('Utwórz nowy')}</Button>
      </div>
    </div>
  );
};

export default ProcessTypeCard;
